import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { AiOutlineRight } from "react-icons/ai";

const ZipInput = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string>("");

  const zip = sessionStorage.getItem("zipCode");

  const validationSchema = Yup.object().shape({
    number: Yup.number()
      .required("Please enter a valid ZIP code")
      .typeError("Please enter a valid ZIP code")
      .positive("Please enter a valid ZIP code")
      .integer("Please enter a valid ZIP code")
      .test(
        "len",
        "Please enter a valid ZIP code",
        (val: any) => val && val.toString().length === 5
      ),
  });

  const onSubmitHandler = (values: any) => {
    sessionStorage.setItem("zipCode", values.number);
    navigate("/get-recommendations/coverage-year");
  };

  const formik = useFormik({
    initialValues: {
      number: zip ? zip : "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitHandler,
  });

  return (
    <div style={{ width: "minmax(90vw, 550px)" }}>
      <form onSubmit={formik.handleSubmit}>
        <div>
          <label
            htmlFor="number"
            className="large-text text-left"
            style={{ fontWeight: 600, paddingBottom: 8 }}
          >
            ZIP Code
          </label>
          <div>
            <input
              id="number"
              name="number"
              type="text"
              style={{
                borderColor:
                  formik.touched.number && formik.errors.number
                    ? "#ff4e00"
                    : "",
                marginBottom: "10px",
              }}
              onChange={formik.handleChange}
              onBlur={() => {
                formik.handleBlur("number");
                setErrorMessage(
                  formik.errors.number ? formik.errors.number : ""
                );
              }}
              value={formik.values.number}
            />
            {formik.touched.number && formik.errors.number ? (
              <p className="text-left color-alert">{errorMessage}</p>
            ) : (
              <p className="text-left">*Required</p>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="button small-only-width-100 small-only-align-center"
            type="submit"
            disabled={formik.values.number.length < 1}
            style={{
              backgroundColor: formik.values.number.length < 1 ? "#CACACA" : "",
              display: "flex",
              alignItems: "center",
              marginBottom: 0,
            }}
          >
            Get Started <AiOutlineRight style={{ marginLeft: "5px" }} />
          </button>
        </div>
      </form>
    </div>
  );
};

export default ZipInput;
